﻿module Sm.UI.Components.Message

open Fable.React
open Fable.React.Props

open Sm.UI.Form

type Props = {
    Text: string
    Icon: IconName option
}

let private icon props =
    match props.Icon with
    | Some icon -> iconFor icon [Class "icon"]
    | None -> nothing

let Info (props: Props) =
    div [Class "message is-info"] [
        icon props
        span [] [str props.Text]
    ]

let Warning message =
    div [Class "message is-warning"] [
        iconFor Warning [Class "icon"]
        span [] [str message]
    ]

let Loading = Info {
    Text = "LOADING"
    Icon = Some Loading
}
